import { useMcpTool } from 'webmcp-react'
import { uiStore } from 'shared/store/uiStore'
import { navigateSchema, NAV_AREA_ROUTES } from 'entities/WebMcp/model/navAreas'
import { okResult, errorResult } from 'entities/WebMcp/lib/toolResult'

/**
 * Registers the WebMCP navigation (UI-driving) tool. Renders nothing.
 * Drives the app via the global uiStore — the second class of WebMCP tool
 * (navigation), alongside the data tools in ContactsTools.
 *
 * Only top-level area navigation is exposed. Per-contact deep-linking was
 * dropped: the /contacts/:id route is write-only and doesn't open a contact on
 * direct navigation (ContactsPage never reads the param). See the spec.
 */
export const NavigationTools = () => {
  useMcpTool({
    name: 'navigate',
    description:
      'Navigate the app to a main area. area is one of: Inboxes, Discover, AI & Automation, Outbound, Contacts, Analytics.',
    input: navigateSchema,
    annotations: { readOnlyHint: true },
    handler: async ({ area }) => {
      try {
        uiStore.changeRouteViaVue({ path: `/${NAV_AREA_ROUTES[area]}` })
        return okResult({ navigated: true, area })
      } catch (e) {
        return errorResult(e)
      }
    },
  })

  return null
}
